import { getCart } from "../utils/getCart";

const giftcardShippingMsg = async () => {
  const cart = await getCart();
  const $shippingMsg = document.querySelector(".free-shipping__wrapper");
  if (!$shippingMsg) {
    return;
  }
  let hasGiftCard = false;
  cart.items.forEach((item) => {
    if (item.gift_card) {
      hasGiftCard = true;
    }
  });
  if (hasGiftCard && cart.item_count === 1) {
    $shippingMsg.classList.add("hidden");
  } else {
    $shippingMsg.classList.remove("hidden");
  }
};

export { giftcardShippingMsg };
